import React, {useEffect, useState} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import PreventTransitionPrompt from '../../../../components/preventTransitionprompt/PreventTransition';
import {Form, Table, Empty} from 'antd';
import {useForm} from 'antd/lib/form/Form';
import http from '../../../../services/httpService';
import {getLanguage, t} from 'react-switch-lang';
import {Spinner} from 'react-bootstrap';
import Swal from "sweetalert2"

const returnValueWithAddon = (value, addOn, isBefore = true) => {
  return value && String(value)?.length > 0
    ? `${isBefore ? addOn : ''}${value}${!isBefore ? addOn : ''}`
    : '';
};
const FindingsTable = ({
  api,
  query,
  sort,
  queryParamName,
  columns,
  rows = 20,
  methods,
  addButtonRef,
  modalEdit = false,
  locale,
  actionsRedirect,
  actionsWidth,
  onClickRow,
  actionsOpenModal,
  updateTable,
  onColumnAdd,
  onColumnEdit,
  onColumnDelete,
  subTableColumns,
  subTableClickRow,
  prefixCls,
  roles,
  revisionId,
  apiAddon = '',
  ...rest
}) => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(0);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = useForm();
  const [validateTrigger, setValidateTrigger] = useState();
  const [sortFilter, setSortFilter] = useState('');

  const fetchData = async () => {
    try {
      const {data} = await http.get(
        revisionId
          ? `${api}?revisionId.equals=${revisionId}&page=0&size=${rows}${
              query ? `&${query}` : ''
            }${sortFilter ? `&${sortFilter}` : ''}${returnValueWithAddon(
              apiAddon,
              '&'
            )}`
          : `${api}?page=0&size=${rows}${query ? `&${query}` : ''}${
              sortFilter ? `&${sortFilter}` : ''
            }${returnValueWithAddon(apiAddon, '&')}`
      );
      setItems(data?.content);
      setHasMore(data?.content.length === rows);
      setPage((page) => page + 1);
    } catch (err) {
      Swal.fire({
        text: `${t("message.errorApi")}`,
        icon: "error",
        confirmButtonText: "OK"
      });    }
  };

  const fetchMoreData = async () => {
    try {
      const {data} = await http.get(
        revisionId
          ? `${api}?revisionId.equals=${revisionId}&page=${page}&size=${rows}${
              query ? `&${query}` : ''
            }${sortFilter ? `&${sortFilter}` : ''}${returnValueWithAddon(
              apiAddon,
              '&'
            )}`
          : `${api}?page=${page}&size=${rows}${query ? `&${query}` : ''}${
              sortFilter ? `&${sortFilter}` : ''
            }${returnValueWithAddon(apiAddon, '&')}`
      );
      setItems([...items, ...data?.content]);
      setHasMore(data?.content?.length === rows);
      setPage((page) => page + 1);
    } catch (err) {}
  };

  useEffect(() => {
    fetchData();
  }, [query, apiAddon, sortFilter]);

  const onTableChange = (pagination, filters, sorter) => {
    if (sorter?.column) {
      setSortFilter(
        `sort=${sorter?.columnKey},${
          sorter.order === 'ascend' ? 'ASC' : 'DESC'
        }`
      );
    } else {
      setSortFilter('');
    }
  };

  const loader = (
    <div className="text-center mt-3">
      <Spinner variant="primary" animation="border" />
    </div>
  );

  return (
    <div style={{paddingBottom: '50px'}}>
      <InfiniteScroll
        next={fetchMoreData}
        hasMore={hasMore}
        loader={loader}
        scrollableTarget="app-body"
        dataLength={items.length}
      >
        <PreventTransitionPrompt when={editingRecord} />
        <Form
          form={form}
          validateTrigger={validateTrigger}
          onFinishFailed={() => {
            setValidateTrigger('onChange');
            form.validateFields(Object.keys(editingRecord));
          }}
        >
          <Table
            onChange={onTableChange}
            locale={{
              emptyText: (
                <Empty
                  description={t('common.noData')}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              ),
              triggerAsc: t('common.ascending'),
              triggerDesc: t('common.descending'),
              cancelSort: t('common.cancelSort'),
            }}
            columns={columns}
            onRow={(record, rowIndex) => {
              return {
                onClick: (event) => {
                  onClickRow(record?.id, record?.revision?.id);
                }, // click row
              };
            }}
            prefixCls={prefixCls}
            dataSource={items}
            sticky={true}
            pagination={false}
          />
        </Form>
      </InfiniteScroll>
    </div>
  );
};

export default FindingsTable;
